import type { ExtensionConfig } from '@goto/shell-common'

import { getOOSArtifactUrl } from '../helpers/experience-helpers'

import { getFeatureFlag } from '../helpers/shell-helpers'
import { UnleashFlags } from '../models/feature-flag.models'
import { createMsTeamsIntegrationConfigIfFlagEnabled } from '../helpers/ms-teams-integration-helpers'

const integrationFlagSuffix = 'oos-meeting'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-app',
  optionalDependencies: ['@goto/oos-meeting-background-service'],
  get url() {
    const version = getFeatureFlag(UnleashFlags.OOS_MEETING_APP_VERSION, 'release')
    return new URL(getOOSArtifactUrl('meeting-extension', version))
  },
  integrations: {
    get msTeams() {
      return createMsTeamsIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
    },
  },
}

export default extensionConfig
